export const getCookieField = (name) => {
    const cookies = document ? document.cookie.split('; ') : null;
    const cookieField = cookies ? cookies.find((pair) => pair.split('=')[0] === name) : null;

    return cookieField ? cookieField.split('=')[1] : null;
};
